'use client'

import { createContext, type ReactNode, use, useReducer } from 'react'

interface NavigationPrototypeContextValue {
  enabled: boolean
}

const NavigationPrototypeContext = createContext<NavigationPrototypeContextValue | null>(null)

interface NavigationPrototypeProviderProps {
  children: ReactNode
  enabled: boolean
}

export function NavigationPrototypeProvider({
  children,
  enabled,
}: NavigationPrototypeProviderProps) {
  const [hasBeenEnabled, markEnabled] = useReducer(() => true, enabled)
  if (enabled && !hasBeenEnabled) {
    markEnabled()
  }

  return (
    <NavigationPrototypeContext.Provider value={{ enabled: enabled || hasBeenEnabled }}>
      {children}
    </NavigationPrototypeContext.Provider>
  )
}

export function useNavigationPrototypeOptional() {
  return use(NavigationPrototypeContext)
}
